<template lang="pug">
div.shop-banner.mb-1.bg-dark.text-center
  img(v-if=" typeof specialOffer.shopImage != 'undefined' && specialOffer.shopImage.mimeType != 'video/mp4'" :src=" 'data:' + specialOffer.shopImage.mimeType + ';base64,'+ specialOffer.shopImage.data")
  video(v-if="typeof specialOffer.shopImage != 'undefined' && specialOffer.shopImage.mimeType == 'video/mp4'" autoplay style="width:100%" muted onloadeddata="this.play();" :loop="specialOffer.shopImage.name.includes('loop')")
    source(type="video/mp4" :src=" 'data:' + specialOffer.shopImage.mimeType + ';base64,'+ specialOffer.shopImage.data")
  div.text-white.bg-dark.px-3.py-2
    div.float-left.py-2 {{ specialOffer.description }}
    div.float-right.py-2.pl-2(v-if="!buttonMode") (Max. {{specialOffer.maxQuantityPerCustomer}} )
    button.btn.btn-primary.btn-md.float-right(
        v-if="buttonMode"
        @click="addOrRemoveSpecialOffer()"
        type="button"
        ) {{ buttonText }}
    input.form-control.float-right(
      style="width: 35px;"
      v-else
      type="text"
      inputmode="numeric" pattern="[0-9]*"
      min="0" step="1" :max="this.specialOffer.maxQuantityPerCustomer"
      v-model.number="productQuantities[specialOffer.product.id]")
    div(style="clear: both;")
</template>

<script>
export default {
  props: {
    productQuantities: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
    specialOffer: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    buttonMode () {
      return this.specialOffer.maxQuantityPerCustomer === 1
    },
    inCart () {
      return this.productQuantities[this.specialOffer.product.id] > 0
    },
    buttonText () {
      return this.inCart ? 'Entfernen' : 'In den Warenkorb'
    }
  },
  watch: {
    productQuantities: {
      handler () {
        if (this.productQuantities[this.specialOffer.product.id] > this.specialOffer.maxQuantityPerCustomer) {
          this.productQuantities[this.specialOffer.product.id] = this.specialOffer.maxQuantityPerCustomer
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    addOrRemoveSpecialOffer () {
      if (this.inCart) {
        this.productQuantities[this.specialOffer.product.id] = 0
      } else {
        this.productQuantities[this.specialOffer.product.id] = 1
      }
    }
  }
}
</script>
<style lang="stylus">
.shop-banner
    img
      max-width 100%
</style>
